import Dexie, { Table } from 'dexie';

import { getCoSyncTreeDB, SyncTreeDAONode } from '@/workerProcessRenderer/scripts/CoSyncEngine/Tree/SyncTreeDB';

import { SyncTreeNode } from './typings';

/**
 * 同步服务的配置DAO
 */
export default class SyncTreeDAO {
  private db!: Dexie;

  private syncTree!: Table<SyncTreeDAONode, number>;

  public ready!: Promise<SyncTreeDAO>;

  constructor(localSyncId: number) {
    const { dexie, syncTree } = getCoSyncTreeDB(localSyncId);
    this.db = dexie;
    this.syncTree = syncTree;
  }

  public async addNode(node: SyncTreeNode): Promise<number> {
    return this.syncTree.add(node);
  }

  public async updateNode(node: SyncTreeNode): Promise<number> {
    return this.syncTree.put(node);
  }

  public async updateNodes(nodes: SyncTreeNode[]) {
    return this.syncTree.bulkPut(nodes);
  }

  public async deleteNode(path: string): Promise<number> {
    return this.syncTree.where({ path }).delete();
  }

  public async deleteNodes(nodes: SyncTreeNode[]) {
    const paths = nodes.map(node => node.path);
    while (paths.length > 0) {
      const path = paths.pop();
      if (path) {
        await this.deleteNode(path);
      }
    }
  }

  public async clear(): Promise<void> {
    return this.syncTree.clear();
  }

  public async removeDb(): Promise<void> {
    return this.db.delete();
  }

  public async getAllNodes(): Promise<SyncTreeDAONode[]> {
    return this.syncTree.toArray();
  }

  public async getNode(path: string): Promise<SyncTreeDAONode | undefined> {
    return this.syncTree.get({ path });
  }
}
